import React, {useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {TextField, InputLabel, createStyles, Theme as AugmentedTheme} from '@material-ui/core';
import { FormContext } from '../../../store/formContext';
import { CustomInputMappingField } from '@tuqqi/common';
import { SET_PHONE_IS_VALID } from '../../../store/types';
import { phoneValidationHelper } from '../../../utils/validationHelper'
import { parsePhoneNumber } from 'libphonenumber-js';
interface IPhone {
    field: CustomInputMappingField,
    value: string,
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
    sourceField: string
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    field: {
        width: '100%',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '.2px',
        lineHeight: '20px',
        color: '#202124',

        "&::placeholder": {
            fontSize: '14px',
        },
    },
    incorrectMessage: {
        fontFamily: 'Rubik, sans-serif',
        color: '#f44336',
        fontSize: '14px',
        display: 'block',
        marginTop: 9,
    },
    //@ts-ignore
    inputLabel: theme.inputLabel,
    //@ts-ignore
    requiredLabel: theme.requiredLabel,
    //@ts-ignore
    requiredField: theme.requiredField,

    errorLabel: {
        color: '#f44336',
    }
}))


export default function PhoneField({ field, value, onChangeHandler, sourceField, isRtl }: IPhone) {
    const classes = useStyles();

    const { dispatch } = useContext<any>(FormContext);

    const [phoneValidationStatus, setPhoneValidationStatus] = useState<boolean>(true);
    const [phoneNumber, setPhoneNumber] = useState<string>('');

    useEffect(() => {
        let val = '';
        if(value.includes('+', 0)) {
            val = value
        } else if(value.length){
            val = `+${value}`
        } 

        if(val.length >= 7) {
            try {
                const phoneNumber = parsePhoneNumber(val);
                const formattedNumber = phoneNumber.formatInternational();
                const isPhoneValid = phoneValidationHelper(val);
                setPhoneValidationStatus(isPhoneValid);
                setPhoneNumber(formattedNumber);
            } catch (e) {
                console.log(e)
                setPhoneNumber(val);
                setPhoneValidationStatus(false)
            }

        } else if (val.length < 7 && val.length !== 0){
            setPhoneValidationStatus(false);
            setPhoneNumber(val);
        } else {
            setPhoneValidationStatus(true);
            setPhoneNumber(val);
        }
        
    },[value])


    useEffect(() => {
        dispatch({type: SET_PHONE_IS_VALID, payload: phoneValidationStatus, sourceField})
    }, [phoneValidationStatus, dispatch, sourceField])

    const isEmpty = !value || value.trim() === ''
    const showRequired = field.required && isEmpty && phoneValidationStatus

    return(
        <>
          <InputLabel
           style={{ 
            direction: isRtl ? 'rtl' : 'ltr',
            textAlign: isRtl ? 'right' : 'left' 
        }} 
         htmlFor={field.sourceField} className={!phoneValidationStatus ? `${classes.inputLabel} ${classes.errorLabel}` : (showRequired ? classes.requiredLabel : classes.inputLabel)}>{field.fieldName}</InputLabel>
            <TextField  
            style={{ 
                direction: isRtl ? 'rtl' : 'ltr',
                textAlign: isRtl ? 'right' : 'left' 
            }} 
                value={phoneNumber} 
                id={field.sourceField} 
                className={`${classes.field} ${showRequired ? classes.requiredField : ''}`} 
                placeholder={field.fieldName} 
                onChange={onChangeHandler}
                name={field.fieldName} 
                type={field.type} 
                required={field.required}
                error={!phoneValidationStatus}                    
            />
            {!phoneValidationStatus && <span className={classes.incorrectMessage}>Phone number is incorrect!</span>}
        </>
    )
}